/**
 * 4px base spacing grid.
 *
 * Standard gaps in the UI spec (§5.9): 4, 8, 12, 16, 20, 24, 32, 48, 64.
 * Card padding: 20 (compact), 24 (default), 32 (spacious).
 * Content max-width 1280px with 32px horizontal padding.
 */

export const spacing = {
  0: '0px',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  8: '32px',
  10: '40px',
  12: '48px',
  16: '64px',
  20: '80px',
  24: '96px',
} as const;

export const cardPadding = {
  compact: spacing[5], // 20px
  default: spacing[6], // 24px
  spacious: spacing[8], // 32px
} as const;

export const contentMaxWidth = '1280px';
export const contentHorizontalPadding = spacing[8]; // 32px

export type SpacingToken = keyof typeof spacing;
